import { MessageCircle } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect } from 'react';

import { Button } from '@portfolio/ui';
import { cn } from '@portfolio/ui/utils';

import { useChat } from '../hooks/useChat';
import { ChatWindow } from './ChatWindow';

interface ChatWidgetProps {
  isOpen: boolean;
  onToggle: () => void;
}

export function ChatWidget({ isOpen, onToggle }: ChatWidgetProps) {
  const chat = useChat();
  const { warmup } = chat;

  useEffect(() => {
    if (isOpen) warmup();
  }, [isOpen, warmup]);

  return (
    <>
      <AnimatePresence>{isOpen && <ChatWindow onClose={onToggle} chat={chat} />}</AnimatePresence>

      <motion.div
        className={cn(
          'fixed right-6 bottom-[max(1.5rem,env(safe-area-inset-bottom))] z-50',
          isOpen && 'hidden sm:block'
        )}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.3 }}
      >
        <Button
          size="lg"
          onClick={onToggle}
          className="h-14 w-14 rounded-full bg-linear-to-br from-accent-indigo to-accent-pink shadow-lg transition-shadow hover:shadow-xl"
        >
          <motion.div animate={{ rotate: isOpen ? 90 : 0 }} transition={{ duration: 0.2 }}>
            <MessageCircle className="h-6 w-6" />
          </motion.div>
        </Button>
      </motion.div>
    </>
  );
}
